// plugins/RouterLoader.js (optimizado)
import MenuService from '../services/Menu.service'
import About from '../views/About.vue'
import Archivo from '../views/Sistema/Archivo.vue'
import SubPantalla from '../views/Categoria/SubPantalla.vue'
import SubPantalla2 from '../views/Categoria/SubPantalla2.vue'
import ABMmenu from '../views/Sistema/ABMmenu.vue'
import AbmEjemplo from '../views/Categoria/AbmEjemplo.vue'
import ABMrol from '../views/Sistema/ABMrol.vue'
import ABMusuario from '../views/Sistema/ABMusuario.vue'
import ABMcomision from '../views/Sistema/ABMcomision.vue'
import Consulta from '../views/Consulta/Consulta.vue'
import DiasNoLaborales from '../views/Planificador/DiasNoLaborales.vue'
import Numerica from '../views/Planificador/Numerica.vue'
import Docente from '../views/Planificador/Docente.vue'
import Disponibilidad from '../views/Docente/Disponibilidad.vue'
import DispoComisionSemestre from '../views/Docente/DispoComisionSemestre.vue'
import Vue from 'vue'

const RouterLoader = async (router, store) => {

  const info = Vue.prototype.$auth?.getAuthInfo?.()
  if (!info || !info.token) {
    console.log("object");
    return; // sin sesión, no cargues menú
  }

  try {
    const response = await MenuService.ObtenerMenu()
    const componentes = {
      About,
      Archivo,
      SubPantalla,
      SubPantalla2,
      ABMmenu,
      ABMusuario,
      ABMcomision,
      AbmEjemplo,
      ABMrol,
      Consulta,
      DiasNoLaborales,
      Numerica,
      Docente,
      Disponibilidad,
      DispoComisionSemestre
    }

    const rutas = response.data
      .filter(r => r.componente)
      .map(m => ({
        path: m.ruta,
        name: m.nombre,
        component: componentes[m.componente],
        meta: { auth: true }
      }))

    response.data.forEach(menu => {
      (menu.submenu || []).forEach(m => {
        rutas.push({
          path: m.ruta,
          name: m.nombre,
          component: componentes[m.componente],
          meta: { auth: true }
        })
      })
    })

    rutas.push({ path: '*', redirect: '/' })

    router.addRoutes(rutas)
    store.usuario.menu = response.data
    added = true
  } catch (e) {
    // opcional: loguear
  }
}

export default RouterLoader
